import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  selector: 'app-pricing-table',
  templateUrl: './pricing-table.component.html',
  styleUrl: './pricing-table.component.css'
})
export class PricingTableComponent {
  
  //Pricing Table
  plans = [
    {
      name: 'Starter Plan',
      subtitle: 'Ideal for Freelancers & Startups',
      price: 59,
      highlight: false,
      features: [
        { text: 'Logo Design', available: true },
        { text: '1 Page Website', available: true },
        { text: 'Social Media Kit', available: false },
        { text: 'Revisions', available: false }
      ]
    },
    {
      name: 'Professional Plan',
      subtitle: 'Perfect for Growing Brands',
      price: 129,
      highlight: true,
      features: [
        { text: 'Logo + Brand Kit', available: true },
        { text: 'Up to 5 Web Pages', available: true },
        { text: 'Responsive Design', available: true },
        { text: '3 Revisions', available: false }
      ]
    },
    {
      name: 'Enterprise Plan',
      subtitle: 'For Agencies & Large Businesses',
      price: 249,
      highlight: false,
      features: [
        { text: 'Full Branding Package', available: true },
        { text: '10+ Web Pages', available: true },
        { text: 'SEO Optimized', available: true },
        { text: 'Unlimited Revisions', available: true }
      ]
    }
  ];

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }

  // OWl Slider
  brandsCarousel: OwlOptions = {
    loop: true,
    dots: false,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "vendor-1.jpg"},
    {img: "vendor-2.jpg"},
    {img: "vendor-3.jpg"},
    {img: "vendor-4.jpg"},
    {img: "vendor-5.jpg"},
    {img: "vendor-6.jpg"}
  ];
}
